export { default } from "./SlicerCard"
